<template>
  <div class="pageBox">
    <div class="content-block">
      <form-card title="修改联系人信息">
        <el-form :model="form" :rules="rules" ref="form" label-width="auto" class="infoForm">
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="联系人姓名" prop="contactName">
                <el-input
                  aria-label="联系人姓名"
                  aria-autocomplete="none"
                  clearable
                  placeholder="请输入联系人姓名"
                  type="text"
                  v-model.trim="form.contactName"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
            <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="联系人手机号码" prop="contactPhone">
                <el-input
                  aria-label="联系人手机号码"
                  aria-autocomplete="none"
                  clearable
                  placeholder="请输入联系人手机号码"
                  type="text"
                  v-model.trim="form.contactPhone"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="联系人邮箱地址" prop="contactEmail">
                <el-input
                  aria-label="联系人邮箱地址"
                  aria-autocomplete="none"
                  clearable
                  placeholder="请输入联系人邮箱地址"
                  type="email"
                  v-model.trim="form.contactEmail"
                  onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'')" 
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item label="微信" prop="weixin">
                <el-input
                  aria-label="微信"
                  aria-autocomplete="none"
                  clearable
                  placeholder="请输入微信"
                  type="text"
                  v-model="form.weixin"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16" :offset="4" :xs="{span:22,offset:0}">
              <el-form-item>
                <el-button type="primary" class="w400" @click="submitForm('form')">提交</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </form-card>
    </div>
  </div>
</template>

<script>
import { checkPhone, checkWeixin } from "@/utils/RegExp.js";

export default {
  created() {
    this.$store.dispatch("accountStore/updateUserData", {}).then((res) => {
      //去后台拿用户资料，更新本地状态
      if (res.code == 0) {
        this.form = Object.assign(this.form, $utils.deepClone(res.data));
      } else {
        this.$message.error("获取资料失败");
      }
    });
  },
  data() {
    return {
      infoStatus: true,
      form: {
        contactName: "",
        contactEmail: "",
        contactPhone: "",
        weixin: "",
      },
      rules: {
        contactName: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
        contactEmail: [
          { required: true, message: "请输入联系人邮箱", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "请输入联系人电话", trigger: "blur" },
          { required: true, validator: checkPhone, trigger: "blur" },
        ],
        weixin: [
          { required: true, message: "请输入联系人微信", trigger: "blur" },
          { required: true, validator: checkWeixin, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // //上传前校验
    // beforeUpload(file) {
    //   const isLt2M = file.size / 1024 / 1024 < 2;
    //   if (!isLt2M) {
    //     this.$message.error("上传图片大小不能超过 2MB!");
    //   }
    //   return isLt2M;
    // },
    // //上传成功
    // handleUpload(res, file, filelist, key) {
    //   if (res.code == 0) {
    //     this.form[key] = res.data.link;
    //   } else {
    //     this.$message.error("上传失败");
    //   }
    // },
    //提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$apis.accountSever.changeContactInfo(this.form).then((res) => {
            if (res.code == 0) {
              this.$store
                .dispatch("accountStore/updateAccountInfo", {})
                .then((res) => {
                  this.$msgBox
                    .alertMessageBox({
                      content: "您的账号资料修改成功",
                    })
                    .then(async (res) => {
                      this.$router.go(-1);
                    })
                    .catch((val) => {});
                });
            } else {
              this.$message.error("提交失败");
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.pageBox {
  padding: 60px 0px 70px 0px;
  height: 100%;
  background-color: #fff;
  .content-block {
    // border: 1px solid rgba(0,0,0,0.1);
    .title {
      position: relative;
      margin: 50px 0;
      font-size: 24px;
    }
    .infoForm {
      padding: 50px 0;
      background: #fff;
      // height: 650px;
      // border: 1px solid rgba(0,0,0,0.1);
    }
  }
}
</style>
